module.exports = __webpack_public_path__ + "img/figure-21.b98ed64b.png";